// extracted by mini-css-extract-plugin
export default {"wrapper":"RecoveryEdit_wrapper__VPyRF","buttons":"RecoveryEdit_buttons__p32XR","inputs":"RecoveryEdit_inputs__4D8vR"};